import React from 'react';
import {IoChatboxOutline} from 'react-icons/io5';
import {AiOutlineSearch} from 'react-icons/ai';
import {FiSettings} from 'react-icons/fi';
import {IoIosNotificationsOutline} from 'react-icons/io';
import AppLanguageSwitcher from '../../AppLanguageSwitcher';
import AppScrollbar from '../../AppScrollbar';
import {useSidebarContext} from '../../../utility/AppContextProvider/SidebarContextProvider';

const BucketMinibar = () => {
  const {sidebarColorSet} = useSidebarContext();
  return (
    <div
      className='bucket-minibar'
      style={{
        backgroundColor: sidebarColorSet.sidebarBgColor,
        color: sidebarColorSet.sidebarTextColor,
      }}>
      <a className='bucket-minibar-logo' onClick={(e) => e.preventDefault()}>
        <img
          src={
            sidebarColorSet.mode === 'dark'
              ? '/assets/images/logo-laju.png'
              : '/assets/images/logo.png'
          }
          alt='ict-logo'
        />
      </a>

      <AppScrollbar className='bucket-minibar-scrollbar' scrollToTop={false}>
        <div className='bucket-minibar-main'>
          <a
            className='bucket-minibar-link'
            onClick={(e) => e.preventDefault()}>
            <AiOutlineSearch />
          </a>

          <AppLanguageSwitcher />

          <a
            className='bucket-minibar-link'
            onClick={(e) => e.preventDefault()}>
            <IoChatboxOutline />
          </a>
          <a
            className='bucket-minibar-link bucket-minibar-notify-link'
            onClick={(e) => e.preventDefault()}>
            <IoIosNotificationsOutline />
          </a>
        </div>
        <div className='bucket-minibar-setting'>
          <a
            className='bucket-minibar-link'
            onClick={(e) => e.preventDefault()}>
            <FiSettings />
          </a>
        </div>
      </AppScrollbar>
    </div>
  );
};

export default BucketMinibar;
